import React from 'react';
import { Drawer } from 'antd';
import AutoCompleteSearch from '../components/AutoComplete';
import { resturantsList } from '../common/utils';

const Search: React.FC = (props: any) => {
  const placeholder = 'Search Resurants or Food...';

  const onClose = () => {
    props.history.push('/resturants');
  };

  return (
    <Drawer
      title={
        <AutoCompleteSearch
          onClose={onClose}
          options={resturantsList}
          placeholder={placeholder}
        />
      }
      placement="top"
      closable={true}
      visible={true}
      height={'100%'}
      onClose={onClose}
    />
  );
};

export default Search;
